module.exports = __webpack_public_path__ + "static/flags/PO-b7ad86ecd20115c8c0c444070cb80fbb.gif";